/* eslint-disable */ 
import React from 'react' ;
import { Dropdown as DropdownImp} from 'primereact/dropdown';


export default function Dropdown (props) {

    return <DropdownImp {...props} />
    
}